<template>
  <b-table
    :loading="isLoading"
    :paginated="paginated"
    :per-page="perPage"
    :striped="isStriped"
    :hoverable="hoverable"
    default-sort="name"
    :data="results"
    slot="content"
  >
    <template slot-scope="props">
      <b-table-column label="Caballo" field="horse.name" sortable><link-to-detail type="horse" :resource-id="props.row.horse.id"> {{`${props.row.horse.name}`}} </link-to-detail></b-table-column>
      <b-table-column label="Fecha Inicio" field="startDate">{{ moment(props.row.start_date, 'YYYY-MM-DD') | moment('LL')}}</b-table-column>
      <b-table-column label="Fecha Termino" field="finishDate" v-if="props.row.end_date != null">{{ moment(props.row.end_date, 'YYYY-MM-DD') | moment('LL')}}</b-table-column>
       <b-table-column label="Fecha Termino" field="finishDate" v-else>
        <p>En curso</p>
      </b-table-column>
      <b-table-column label="Activo" field="active" sortable>
        <b-icon icon="toggle-switch" type="is-success" v-if="props.row.active == true"></b-icon>
        <b-icon icon="toggle-switch-off" v-else>
        </b-icon>
      </b-table-column>
    </template>

    <section class="section" slot="empty">
      <div class="content has-text-grey has-text-centered">
        <template v-if="isLoading">
          <p>
            <b-icon icon="dots-horizontal" size="is-large" />
          </p>
          <p>Cargando Resultados...</p>
        </template>
        <template v-else>
          <p>
            <b-icon icon="horseshoe" size="is-large" />
          </p>
          <p>No hay Resultados&hellip;</p>
        </template>
      </div>
    </section>
  </b-table>
</template>

<script>
import TenantService from '@/services/TenantService'
import LinkToDetail from '@/components/LinkToDetail'

export default {
  components: {
    LinkToDetail
  },
  props: {
    riderId: {
      required: true
    }
  },
  created () {
    this.getHistory()
  },
  data () {
    return {
      results: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      hoverable: true,
      isLoading: false,
      numberResult: 0
    }
  },
  methods: {
    async getHistory () {
      this.isLoading = true
      let params = {
        'rider_id': this.riderId,
        'include[0]': 'horse'
      }
      let response = await TenantService.getHistoryAssignments(params)
      this.results = response.data.data
      this.numberResult = this.results.length
      this.isLoading = false
    }
  },
  watch: {
    riderId (value) {
      this.getHistory()
    },
    numberResult (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>
